import Content from "./index";

export default {
	path: 'search',
	name: 'Search',
	component: Content
};
